export default __webpack_public_path__ + "static/25_18-b52e0bf546390fbc7bc7d3b0a1f90221.png";